// @flow
import {
  type FolderState,
} from './types';
import {
  sortingType,
} from '../types';

const initialState: FolderState = {
  selectedContentItems: new Map(),
  inReorderingMode: false,
  currentSortType: {
    name: sortingType.ORIGINAL,
    isAscending: false,
  },
  currentFolder: null,
};

const folderFlashcardsOnlyNumericIds = [1705256, 1705257, 1705258,
  1705259, 1705260, 1705261,
  1705262, 1705263, 1705270,
  1705283, 1705290, 1705297,
  1705298, 1705305, 1705306, 1701035, 1701036, 1701043,
  1701044, 1701045, 1701046,
  1701047, 1701054, 1701061,
  1701062, 1701063, 1701064,
  1701065, 1701066, 1701067,
  1701068, 1701069, 1701070,
  1701071, 1701072, 1706891, 1706892, 1706915,
  1706916, 1706917, 1706918,
  1706919, 1706920, 1706921,
  1706922, 1706923, 1706924,
  1706925, 1706926, 1706927, 1707533, 1707534, 1707535,
  1707536, 1707548, 1707549,
  1707550, 1707551, 1707579,
  1707580, 1707581, 1707589,
  1707590, 1707591, 1707598,
  1707599, 1707601, 1707608,
  1707609, 1707610, 1707611,
  1707612, 1707613, 1707614, 1707623, 1707634,
  1707635, 1707636,
  1707637, 1707638,
  1707640, 1708069,
  1708076, 1708077,
  1708078, 1708079,
  1708093, 1708100,
  1708222, 1708223, 1708224, 1708225,
  1708226, 1708227, 1708228, 1708229,
  1708230, 1708231, 1708232, 1708233,
  1708253, 1708254, 1708255, 1708256,
  1708264, 1708265, 1708266, 1708267,
  1708268, 1708269, 1708281, 1708282,
  1708283, 1708284, 1708285, 1708286,
  1708287, 1708288];
export {
  folderFlashcardsOnlyNumericIds,
  initialState,
};
